import { render, staticRenderFns } from "./ingredientes.vue?vue&type=template&id=213d5214"
import script from "./ingredientes.vue?vue&type=script&lang=js"
export * from "./ingredientes.vue?vue&type=script&lang=js"
import style0 from "./ingredientes.vue?vue&type=style&index=0&id=213d5214&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports